export class LocalStorageKeys {
  static readonly ACCESS_TOKEN = 'access_token';
  static readonly USER_PREFERENCES = 'user_preferences';
  static readonly USER_DETAILS = 'user_details';
  static readonly THEME = 'theme';
}
